import HummingBeeBreath from '@/components/Exercises/HummingBee/HummingBeeBreath'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(content)/children/exercises/(shared)/humming-bee-breath/',
)({
  component: RouteComponent,
    head: () => ({
    meta: [
      {
        title: "Humming Bee Breath - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "hummingBee.title",
    navbar: {
      showTitle: true,
    },
  }),
})

function RouteComponent() {
  return (
    <HummingBeeBreath />
  )
}
